import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import { State } from '../store/schema/State';

export const setStoreState = mutatorAction('SET_TRUETIME_STORE_STATE', (state: State) => {
    getStore().state = state;
});
